import script from "./AboutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=75dc04cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75dc04cd"]])

export default __exports__